var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,5a9.81,9.81,0,0,0-6.75,2.55A9.84,9.84,0,0,0,11.29,5c-5.2,0-9.77,4.31-9.77,9.22a13.84,13.84,0,0,0,1.14,5.12l.18,0h0c1.74,0,3.77,0,5.74,0h3.81c.13,0,.15,0,.21-.19q.84-2.86,1.7-5.72l.22-.74a1.39,1.39,0,0,1,1.26-1.13,1.36,1.36,0,0,1,1.43,1.16l2.1,7.43.84-2.36a1.36,1.36,0,0,1,1.38-1.05h3.26a1.48,1.48,0,0,1,1.46,1.53,1.61,1.61,0,0,1-.44,1.13,1.45,1.45,0,0,1-1,.42H22.59c-.14,0-.16,0-.22.18-.46,1.33-.92,2.65-1.39,4l-.39,1.13c-.35,1-.92,1.2-1.36,1.2h-.05c-.65,0-1.1-.45-1.34-1.28l-2-6.91-.89,3.05c-.26.9-.69,1.25-1.53,1.25H4.23A27.6,27.6,0,0,0,7.35,26.6c3.54,3.87,7.63,6.28,10.7,6.28s7.16-2.41,10.69-6.28S34.57,18,34.57,14.23C34.57,9.32,30,5,24.8,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLevel);
export default __webpack_public_path__ + "static/media/activity-level.7081085fdcab7a8a23749e5590f32ed0.svg";
export { ForwardRef as ReactComponent };